<template>
  <div
    :class="{
      rightMenu: true,
      rightMenuTwo: isMode == 'leftHide',
    }"
    ref="rightMenu"
  >
    <!-- 头部 -->
    <div class="bottomBox" v-show="isBottom" ref="bottomBox" :style="fixedTop">
      <!-- 发帖子 -->
      <div class="oneBox" @click="release">
        <div class="one">
          <svg-btn class="icon2" icon-class="icon-release"></svg-btn>
          <span class="font">发帖子</span>
        </div>
        <svg-btn class="right" icon-class="icon-right"></svg-btn>
      </div>
      <!-- 热门用户骨架屏 -->
      <div class="twoBox" v-show="loading">
        <div class="skeleton-user-box">
          <div class="hotTitle skeleton-placeholder"></div>
          <div class="skeleton-user-item" v-for="i in 3" :key="i">
            <div class="skeleton-left-list">
              <div class="skeleton-head skeleton-placeholder"></div>
              <div class="skeleton-right-list">
                <div class="skeleton-nickname skeleton-placeholder"></div>
                <div class="skeleton-fans skeleton-placeholder"></div>
              </div>
            </div>
            <div class="skeleton-follow-btn skeleton-placeholder"></div>
          </div>
        </div>
      </div>
      <!-- 热门用户 -->
      <div
        class="twoBox"
        v-show="
          !loading &&
          $route.name != 'jx' &&
          $route.name != 'vd' &&
          hotUserList.length > 0
        "
      >
        <div class="hotTitle">热门用户</div>
        <div
          class="userBox"
          @click="toUser(item)"
          v-for="(item, index) in hotUserList"
          :key="index"
        >
          <div class="leftList">
            <el-image :src="item.logo" fit="cover" class="head">
              <img
                width="48"
                height="48"
                slot="error"
                class="error-headImg"
                :src="$utils.getPng('icon-gfans-defaultHead')"
              />
            </el-image>
            <div class="rightList">
              <div class="font2">{{ item.nickname }}</div>
              <div class="font3">{{ item.fans }}订阅</div>
            </div>
          </div>
          <div
            @click.stop="check(item, index)"
            v-show="item.is_follow != -1"
            :class="{
              textBtn: item.is_follow != 1,
              activeBtn: item.is_follow == 1,
            }"
          >
            {{ item.is_follow == 1 ? '已订阅' : '订阅' }}
          </div>
        </div>
      </div>
      <!-- TA的最新动态 -->
      <div
        class="twoBox new"
        v-show="
          ($route.name == 'jx' || $route.name == 'vd') && newList.length > 0
        "
      >
        <div class="hotTitle">TA的最新动态</div>
        <div
          class="newBox"
          @click="toDetail(item)"
          v-for="(item, index) in newList"
          :key="index"
        >
          <div class="imgBox">
            <el-image :src="item.cover" :fit="'cover'" class="leftImg">
              <div slot="error" class="error-headImg2"></div>
            </el-image>
            <div class="stop" v-if="item.stype == 2">
              <svg-btn class="stopIcon" icon-class="icon-video-stop"></svg-btn>
            </div>
          </div>
          <div class="rightf">{{ item.name }}</div>
        </div>
      </div>
      <!-- 热门标签骨架屏 -->
      <div class="twoBox" v-if="loading">
        <!-- 热门标签骨架屏 -->
        <div class="skeleton-tab-box">
          <div class="hotTitle skeleton-placeholder"></div>
          <div class="skeleton-tabs">
            <div
              class="skeleton-tab skeleton-placeholder"
              v-for="i in 6"
              :key="i"
            ></div>
          </div>
        </div>
      </div>
      <!-- 热门标签 -->
      <div class="twoBox" v-show="!loading && tabList.length > 0">
        <div class="hotTitle">热门标签</div>
        <div class="tabBox">
          <div
            class="tab"
            @click="toTab(item)"
            v-for="(item, index) in tabList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 切换主题 -->
      <div class="themeBox">
        <div
          v-for="item in themeList"
          class="one"
          :class="{ one2: $store.state.themeBtn == item }"
          @click="changeTheme(item)"
          :key="item"
        >
          <svg-btn :icon-class="'icon-switch-' + item" />
        </div>
      </div>
    </div>
    <PromptTip
      @confirm="confirm"
      @handleClose="handleClose"
      tips="确认取消订阅该订阅号？"
      :isShow="isShow"
    />
  </div>
</template>

<script>
import { checkModirlt } from '@/axios/home'
import ClickPop from '@/components/ClickPop/index.vue'
import PromptTip from '@/components/PromptTip/index'
import { eventBus } from '@/utils/event-bus'
import { getHotList } from '@/axios/common'
export default {
  components: {
    ClickPop,
    PromptTip,
  },
  props: {
    isMode: {
      type: String,
      default: 'none',
    },
  },
  data() {
    return {
      hotUserList: [], //热门用户数组
      newList: [], //最新动态数组
      tabList: [], //热门标签数组
      themeList: ['system', 'light', 'dark'], //主体数组
      isFixed: false,
      fixedTop: '72px', // 头部高度
      allHeight: '', //视图高度
      bottomBoxHeight: '', //容器高度
      isSize: false,
      isBottom: true,
      isShow: false,
      uid: '',
      act: '',
      loading: true,
    }
  },
  watch: {
    // 监听路由变化
    $route(to) {
      this.$nextTick(() => {
        //每次路由跳转都得重新计算一次高度
        if (
          to.name === 'home' ||
          to.name === 'subscribe' ||
          to.name === 'user'
        ) {
          this.fixedTop = `top:72px`
          this.allHeight = window.innerHeight // 视口高度
          this.updateContainerHeight()
          this.isSize = true
          setTimeout(() => {
            this.isSize = false
          }, 500)
        } else {
          this.fixedTop = `top:72px`
          this.allHeight = window.innerHeight // 视口高度
          this.updateContainerHeight()
        }
      })
    },
  },
  mounted() {
    // 监听更新热门数据事件
    eventBus.$on('upHotList', () => {
      this.getHot()
    })
    // 监听更新热门数据事件
    eventBus.$on('upNewList', arr => {
      this.newList = arr
      this.$nextTick(() => {
        this.updateContainerHeight()
      })
    })
    this.allHeight = window.innerHeight // 视口高度
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    this.getHot()
  },
  beforeDestroy() {
    eventBus.$off('upHotList')
    eventBus.$off('upNewList')
    eventBus.$off('upFixedTop')
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    //获取热门数据
    async getHot() {
      try {
        let res = await getHotList()
        if (res.status == 1) {
          this.hotUserList = res.data.list
          this.tabList = res.data.tag
          this.$nextTick(() => {
            this.updateContainerHeight()
          })
          this.loading = false
        }
      } catch (error) {}
    },
    //跳转个人中心
    toUser: _.debounce(
      function (item) {
        if (this.$store.state.isLogin == 0) {
          eventBus.$emit('showLogin', {})
          return
        }
        this.$router.push({
          name: 'user',
          params: { uid: item.userid },
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //发布
    release() {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      window.open(
        this.$glb.upJmdyhUrl +
          `/subscribe?platfro=${localStorage.getItem('platfro')}`,
        '_blank'
      )
    },
    //查看标签页
    toTab(item) {
      const route = this.$router.resolve({
        name: 'tab',
        params: { id: item.only_code },
      })
      window.open(route.href, '_blank')
    },
    //查看详情页
    toDetail(item) {
      // if (this.$store.state.isLogin == 0) {
      //   eventBus.$emit('showLogin', {})
      //   return
      // }
      //stype为1是文章，2是视频
      const routeName = item.stype == 1 ? 'jx' : 'vd'
      const route = this.$router.resolve({
        name: routeName,
        params: { id: item.fshort },
      })
      window.open(route.href, '_blank')
    },
    //点击订阅
    check(item, index) {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      if (item.is_follow == 0) {
        this.checkDy(item, index)
      } else {
        //点击取消订阅
        this.uid = item.userid
        this.act = 2
        this.isShow = true
      }
    },
    //点击订阅
    checkDy: _.debounce(
      async function (item, index) {
        let act = this.hotUserList[index].is_follow == 1 ? 2 : 1
        try {
          let res = await checkModirlt({
            uid: item.userid,
            act: act,
          })
          if (res.status == 1) {
            await this.getHot()
            //如果停留在发现页面，需要刷新发现页面，以免导致中间和右边订阅状态不同步
            if (this.$route.name == 'home') {
              // eventBus.$emit('upHomeList')
              this.updateHomePage({
                userid: item.userid,
                is_follow: 1,
              })
            }
            //如果停留在我的订阅页面，需要刷新发现页面，以免导致中间和右边订阅状态不同步
            if (this.$route.name == 'subscribe') {
              eventBus.$emit('upSubscribeList')
              this.updateHomePage({
                userid: item.userid,
                is_follow: 1,
              })
            }
            //如果停留在个人主页页面，需要刷新用户信息，更新用户帖子订阅状态
            if (this.$route.name == 'user') {
              eventBus.$emit('upUserList')
            }
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        } catch (error) {}
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //点击订阅
    confirm: _.debounce(
      async function () {
        try {
          let res = await checkModirlt({
            uid: this.uid,
            act: this.act,
          })
          if (res.status == 1) {
            await this.getHot()
            //如果停留在发现页面，需要刷新发现页面，以免导致中间和右边订阅状态不同步
            if (this.$route.name == 'home') {
              // eventBus.$emit('upHomeList')
              this.updateHomePage({
                userid: this.uid,
                is_follow: 0,
              })
            }
            //如果停留在我的订阅页面，需要刷新发现页面，以免导致中间和右边订阅状态不同步
            if (this.$route.name == 'subscribe') {
              eventBus.$emit('upSubscribeList')
              this.updateHomePage({
                userid: this.uid,
                is_follow: 0,
              })
            }
            //如果停留在个人主页页面，需要刷新用户信息，更新用户帖子订阅状态
            if (this.$route.name == 'user') {
              eventBus.$emit('upUserList')
            }
            this.handleClose()
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        } catch (error) {}
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //关闭取消订阅弹窗
    handleClose() {
      this.uid = ''
      this.act = ''
      this.isShow = false
    },
    //滚动方法
    handleScroll: _.debounce(
      function () {
        if (this.isSize || this.$route.name == 'notice') {
          return
        }
        const scrollY = window.scrollY // 当前滚动距离
        // 如果容器高度小于视图高度，直接返回，不执行后续逻辑
        if (this.bottomBoxHeight < this.allHeight) {
          // console.log('容器高度小于视图高度，不执行后续逻辑')
          this.allHeight = window.innerHeight // 视口高度
          this.updateContainerHeight()
          return
        }
        const bottomBox = this.$refs.rightMenu?.querySelector('.bottomBox')
        // 记录上次滚动位置，初始值设为当前滚动位置
        if (this.lastScrollY === null) {
          this.lastScrollY = scrollY
          return
        }

        // 判断滚动方向
        const scrollDirection = scrollY > this.lastScrollY ? 'down' : 'up'
        this.lastScrollY = scrollY

        // 获取元素高度
        const elementHeight = bottomBox.offsetHeight

        // 计算动态底部距离 (当滚动到顶部时为72px，滚动越多距离越小)
        const maxBottomDistance = 72 // 最大底部距离 (滚动到顶部时)
        const minBottomDistance = 20 // 最小底部距离 (滚动到底部时)
        const scrollPercentage = Math.min(
          scrollY / (document.documentElement.scrollHeight - this.allHeight),
          1
        )
        const dynamicBottomDistance =
          maxBottomDistance -
          (maxBottomDistance - minBottomDistance) * scrollPercentage
        // 向下滚动逻辑
        if (scrollDirection === 'down') {
          // 当滚动超过视口高度时固定到底部
          this.isFixed = true
          this.fixedTop = `top:${this.allHeight - elementHeight}px`
        }
        // 向上滚动逻辑
        else {
          this.isFixed = false
          this.fixedTop = `bottom:${dynamicBottomDistance}px`
        }
      },
      10,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 统一高度测量方法
    updateContainerHeight() {
      const container = this.$refs.bottomBox
      if (container) {
        // 使用 getBoundingClientRect 获取精确高度
        const rect = container.getBoundingClientRect()
        this.bottomBoxHeight = rect.height + 72
      }
    },
    //页面尺寸变化
    handleResize() {
      if (this.$route.name == 'notice') {
        return
      }
      this.allHeight = window.innerHeight
      // this.updateContainerHeight();  // 使用统一的高度更新方法
      // 恢复到顶部,注释是因为如果已经滑到底部了，如果右侧回到顶部，因为容器已经到底部了可能会导致，滑动不了右侧,但是如果不设置
      // 会导致如果滑动到底部了，尺寸变大到不能滚动，会导致右侧无法滑动
      this.fixedTop = `top:72px`
      this.isBottom = false
      this.$nextTick(() => {
        this.isBottom = true
      })
      this.isSize = true
      setTimeout(() => {
        this.isSize = false
      }, 500)
    },
    //主题切换
    changeTheme(item) {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      this.$store.commit('setAttr', {
        name: 'themeBtn',
        val: item,
      })
      if (item == 'light' || item == 'dark') {
        this.$utils.changeTheme(item)
      } else {
        this.listenTheme(1)
      }
    },
    listenTheme(index = 0) {
      const darkModeMediaQuery = window.matchMedia(
        '(prefers-color-scheme: dark)'
      )
      if (this.$store.state.themeBtn == 'system' && index == 1) {
        if (darkModeMediaQuery.matches) {
          this.$utils.changeTheme('dark')
        } else {
          this.$utils.changeTheme('light')
        }
      }
      const darkModeChanged = e => {
        // 当深色模式状态发生变化时，执行相应的操作
        if (this.$store.state.themeBtn == 'system') {
          if (darkModeMediaQuery.matches) {
            this.$utils.changeTheme('dark')
          } else {
            this.$utils.changeTheme('light')
          }
        }
      }
      darkModeMediaQuery.addListener(darkModeChanged)
    },
    // 批量更新多个字段并通知中间页面
    updateHomePage(updatedFields) {
      // 合并需要更新的字段
      const dataToUpdate = {
        userid: updatedFields.userid,
        ...updatedFields,
      }
      // 发送事件通知页面更新
      eventBus.$emit('itemUpdated', dataToUpdate)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
